<form #f="ngForm" (ngSubmit)="filter(f)" ngNativeValidate class="was-validated">
  <div class="form-group">
    <label for="">Ingrese codigo barra {{ entity }}</label>
    <input 
      (keydown)="handleKeyDown($event)" 
      #txtcode 
      [(ngModel)]="codigo" 
      (input)="onInputChange()"
      autocomplete="off"
      type="text" 
      class="form-control" 
      name="codigo"
      id="codigo" 
      aria-describedby="helpId" 
      placeholder="código de barra" />I

    <!-- Sugerencias (dropdown) -->
    <div class="sugerencias-container position-absolute w-100 bg-white shadow" *ngIf="mostrandoSugerencias">
      <ul class="list-group list-group-flush" role="listbox">
        <li class="list-group-item list-group-item-action pointer"
            *ngFor="let sug of sugerencias; let i = index"
            [class.active]="i === indiceActivo"
            (click)="seleccionarSugerencia(sug)"
            tabindex="-1"
            role="option"
            (keydown)="onKeyDownSugerencia($event, i, sug)">
          <strong>{{ sug.serie }}</strong> – {{ sug.nombre }}
          <small class="text-muted float-end">
            Stock: {{ sug.stock }} | {{ sug.precioCon | currency }}
          </small>
        </li>
      </ul>
    </div>
      <ng-container *ngIf="item.nombre == 'no se encontro producto'; then vacio; else data">
    </ng-container>
    <ng-template #vacio>
      <small id="helpId" class="text-danger"> {{ item?.nombre }} </small>
    </ng-template>
    <ng-template #data>
      <ng-container *ngIf="item.nombre == ''; then sin; else prod"></ng-container>
      <ng-template #sin>
        <small id="helpId" class="text-mute"> {{ entity }} </small>
      </ng-template>
      <ng-template #prod>
        <small id="helpId" class="text-success">
          {{ entity }} {{ item?.nombre }} {{item?.precioCon}}
        </small>
      </ng-template>
    </ng-template>
  </div>
</form>

<!-- Button trigger modal -->
<button class="invisible" (click)="focusss()" #lunch data-toggle="modal" data-target="#modelId"></button>

<!-- Modal -->
<ng-template #modalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Listado Producto</h5>
    <button type="button" class="close" (click)="modal.dismiss()">&times;</button>
  </div>

  <div class="modal-body">
    <!-- Contenedor con margen y padding -->
    <div class="container-fluid p-3">
      <app-fil-mercaderia [foco]="focus" (filter)="doFound($event)">
      </app-fil-mercaderia>

      <div class="row table-responsive mt-3">
        <table class="table table-striped table-bordered shadow-sm">
          <thead class="thead-inverse bg-light">
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Stock</th>
              <th>Contado</th>
              <th>Lista</th>
              <th>Imagen</th>
              <th>Agregar</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{ item.serie }}</td>
              <td>{{ item.nombre }}</td>
              <td>{{ item.stock }}</td>
              <td>{{ item.precioCon | currency }}</td>
              <td>{{ item.precioLis | currency }}</td>
              <td>
                <app-image-preview [imgsrc]="item.photo"></app-image-preview>
              </td>
              <td>
                <button type="button" #closed (click)="selected(item)" class="btn btn-success btn-sm">
                  <i class="fas fa-arrow-right"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>